import {
  PeoplePageSourceDerivedQuestionSectionAttributes,
  PeoplePageSourceDerivedSignalSectionAttributes,
  SourcePageTemplate,
} from 'api/custom-section/types';
import { useCallback, useState } from 'react';
import {
  ClosePeoplePageDerivedSectionSourcesUpdater,
  CustomSectionComponentProps,
} from '../../../types/component-types';

export type PeoplePageSourceDerivedQuestionSectionComponentProps =
  | CustomSectionComponentProps<PeoplePageSourceDerivedQuestionSectionAttributes>
  | CustomSectionComponentProps<PeoplePageSourceDerivedSignalSectionAttributes>;

type Props = PeoplePageSourceDerivedQuestionSectionComponentProps & {
  onConfigurationChange: (configuration: {
    sourcePageTemplates: SourcePageTemplate[];
  }) => void;
};
export const useSourcesUpdaterState = ({
  peoplePageDerivedSectionSourcesUpdater: derivedSectionSourcesUpdater,
  getPos,
  editor,
  onConfigurationChange,
}: Props) => {
  const [sourcesUpdateInProgress, setSourcesUpdateInProgress] = useState(false);
  const [closeUpdater, setCloseUpdater] =
    useState<ClosePeoplePageDerivedSectionSourcesUpdater | null>(null);
  const hasSourcePageTemplateSectionsUpdater = !!derivedSectionSourcesUpdater;
  const invokeSourcePageTemplateSectionsUpdater = useCallback(
    (latestNode) => {
      const nodePos = getPos();

      if (derivedSectionSourcesUpdater && nodePos) {
        setSourcesUpdateInProgress(true);
        const closeUpdater = derivedSectionSourcesUpdater({
          node: latestNode,
          nodePosition: nodePos,
          onUpdate: (sourcePageTemplates) => {
            onConfigurationChange({
              sourcePageTemplates: sourcePageTemplates,
            });
            setSourcesUpdateInProgress(false);
          },
          onCancel: () => {
            setSourcesUpdateInProgress(false);
          },
          editor,
        });

        setCloseUpdater(() => closeUpdater);
      }
    },
    [derivedSectionSourcesUpdater, getPos, editor, onConfigurationChange],
  );
  const closePendingUpdater = useCallback(() => {
    if (closeUpdater) {
      closeUpdater();
      setCloseUpdater(() => null);
    }
  }, [closeUpdater]);

  return {
    hasSourcePageTemplateSectionsUpdater,
    invokeSourcePageTemplateSectionsUpdater,
    sourcesUpdateInProgress,
    closePendingUpdater,
  };
};
